module.exports = __webpack_public_path__ + "b058c7a9ecdb00012d66924b422c54e6.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/td-icons.woff
 ** module id = 26
 ** module chunks = 0
 **/